module.exports = __webpack_public_path__ + "static/media/platform.f2a5bba2.svg";